// src/app/redux/reducers/skillEvaluationReducer.js

import {
    FETCH_SKILL_EVALS_BY_CAMPAGNE_REQUEST, FETCH_SKILL_EVALS_BY_CAMPAGNE_SUCCESS, FETCH_SKILL_EVALS_BY_CAMPAGNE_FAIL,
    FETCH_SKILL_EVALS_BY_USER_REQUEST, FETCH_SKILL_EVALS_BY_USER_SUCCESS, FETCH_SKILL_EVALS_BY_USER_FAIL,
    CREATE_SKILL_EVAL_REQUEST, CREATE_SKILL_EVAL_SUCCESS, CREATE_SKILL_EVAL_FAIL,
    UPDATE_SKILL_EVAL_REQUEST, UPDATE_SKILL_EVAL_SUCCESS, UPDATE_SKILL_EVAL_FAIL,
    DELETE_SKILL_EVAL_REQUEST, DELETE_SKILL_EVAL_SUCCESS, DELETE_SKILL_EVAL_FAIL,
    SET_SKILL_EVAL_LOADING, CLEAR_SKILL_EVAL_ERROR,
    SUBMIT_AUTO_EVAL_REQUEST, SUBMIT_AUTO_EVAL_SUCCESS, SUBMIT_AUTO_EVAL_FAIL,
    SKILL_MANAGER_DECISION_REQUEST, SKILL_MANAGER_DECISION_SUCCESS, SKILL_MANAGER_DECISION_FAIL,
    SKILL_N2_DECISION_REQUEST, SKILL_N2_DECISION_SUCCESS, SKILL_N2_DECISION_FAIL,
    FETCH_SKILL_MANAGER_INBOX_REQUEST, FETCH_SKILL_MANAGER_INBOX_SUCCESS, FETCH_SKILL_MANAGER_INBOX_FAIL,
    FETCH_SKILL_N2_INBOX_REQUEST, FETCH_SKILL_N2_INBOX_SUCCESS, FETCH_SKILL_N2_INBOX_FAIL,
    FETCH_SKILL_PEER_INBOX_REQUEST, FETCH_SKILL_PEER_INBOX_SUCCESS, FETCH_SKILL_PEER_INBOX_FAIL,
    FETCH_SKILL_RF_INBOX_REQUEST, FETCH_SKILL_RF_INBOX_SUCCESS, FETCH_SKILL_RF_INBOX_FAIL,
    FETCH_CONSOLIDATED_RESULTS_REQUEST, FETCH_CONSOLIDATED_RESULTS_SUCCESS, FETCH_CONSOLIDATED_RESULTS_FAIL,
    GENERATE_PEER_PROPOSALS_REQUEST, GENERATE_PEER_PROPOSALS_SUCCESS, GENERATE_PEER_PROPOSALS_FAIL,
    CONFIRM_PEER_ASSIGNMENTS_REQUEST, CONFIRM_PEER_ASSIGNMENTS_SUCCESS, CONFIRM_PEER_ASSIGNMENTS_FAIL,
} from "../actions/skillEvaluationActions";

const initialState = {
    skillEvaluations: [],
    inboxManager: [],
    inboxN2: [],
    inboxPeers: [],
    inboxRf: [],
    consolidatedResults: [],
    loading: false,
    error: null,
};

export default function skillEvaluationReducer(state = initialState, action) {
    switch (action.type) {

        case SET_SKILL_EVAL_LOADING:
            return { ...state, loading: action.payload };

        case CLEAR_SKILL_EVAL_ERROR:
            return { ...state, error: null };

        case FETCH_SKILL_EVALS_BY_CAMPAGNE_REQUEST:
        case FETCH_SKILL_EVALS_BY_USER_REQUEST:
        case CREATE_SKILL_EVAL_REQUEST:
        case UPDATE_SKILL_EVAL_REQUEST:
        case DELETE_SKILL_EVAL_REQUEST:
        case SUBMIT_AUTO_EVAL_REQUEST:
        case SKILL_MANAGER_DECISION_REQUEST:
        case SKILL_N2_DECISION_REQUEST:
        case FETCH_SKILL_MANAGER_INBOX_REQUEST:
        case FETCH_SKILL_N2_INBOX_REQUEST:
        case FETCH_SKILL_PEER_INBOX_REQUEST:
        case FETCH_SKILL_RF_INBOX_REQUEST:
        case FETCH_CONSOLIDATED_RESULTS_REQUEST:
        case GENERATE_PEER_PROPOSALS_REQUEST:
        case CONFIRM_PEER_ASSIGNMENTS_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_SKILL_EVALS_BY_CAMPAGNE_SUCCESS:
        case FETCH_SKILL_EVALS_BY_USER_SUCCESS:
            return { ...state, loading: false, skillEvaluations: action.payload || [] };

        case CREATE_SKILL_EVAL_SUCCESS:
            return { ...state, loading: false, skillEvaluations: [...state.skillEvaluations, action.payload] };

        case UPDATE_SKILL_EVAL_SUCCESS:
        case SUBMIT_AUTO_EVAL_SUCCESS:
            return {
                ...state,
                loading: false,
                skillEvaluations: state.skillEvaluations.map((e) =>
                    e.id === action.payload.id ? action.payload : e
                ),
            };

        case SKILL_MANAGER_DECISION_SUCCESS:
            return {
                ...state,
                loading: false,
                inboxManager: state.inboxManager.filter((e) => e.id !== action.payload.id),
                skillEvaluations: state.skillEvaluations.map((e) =>
                    e.id === action.payload.id ? action.payload : e
                ),
            };
        
        case SKILL_N2_DECISION_SUCCESS:
            return {
                ...state,
                loading: false,
                inboxN2: state.inboxN2.filter((e) => e.id !== action.payload.id),
                skillEvaluations: state.skillEvaluations.map((e) =>
                    e.id === action.payload.id ? action.payload : e
                ),
            };


        case FETCH_SKILL_MANAGER_INBOX_SUCCESS:
            return { ...state, loading: false, inboxManager: action.payload || [] };

        case FETCH_SKILL_N2_INBOX_SUCCESS:
            return { ...state, loading: false, inboxN2: action.payload || [] };


        case FETCH_SKILL_PEER_INBOX_SUCCESS:
            return { ...state, loading: false, inboxPeers: action.payload || [] };

        case FETCH_SKILL_RF_INBOX_SUCCESS:
            return { ...state, loading: false, inboxRf: action.payload || [] };

        case FETCH_CONSOLIDATED_RESULTS_SUCCESS:
            return { ...state, loading: false, consolidatedResults: action.payload || [] };

        case GENERATE_PEER_PROPOSALS_SUCCESS:
            return { ...state, loading: false, skillEvaluations: action.payload || [] };

        case CONFIRM_PEER_ASSIGNMENTS_SUCCESS:
            return { ...state, loading: false };

        case DELETE_SKILL_EVAL_SUCCESS:
            return {
                ...state,
                loading: false,
                skillEvaluations: state.skillEvaluations.filter((e) => e.id !== action.payload.id),
            };

        case FETCH_SKILL_EVALS_BY_CAMPAGNE_FAIL:
        case FETCH_SKILL_EVALS_BY_USER_FAIL:
        case CREATE_SKILL_EVAL_FAIL:
        case UPDATE_SKILL_EVAL_FAIL:
        case DELETE_SKILL_EVAL_FAIL:
        case SUBMIT_AUTO_EVAL_FAIL:
        case SKILL_MANAGER_DECISION_FAIL:
        case SKILL_N2_DECISION_FAIL:
        case FETCH_SKILL_MANAGER_INBOX_FAIL:
        case FETCH_SKILL_N2_INBOX_FAIL:
        case FETCH_SKILL_PEER_INBOX_FAIL:
        case FETCH_SKILL_RF_INBOX_FAIL:
        case FETCH_CONSOLIDATED_RESULTS_FAIL:
        case GENERATE_PEER_PROPOSALS_FAIL:
        case CONFIRM_PEER_ASSIGNMENTS_FAIL:
            return { ...state, loading: false, error: action.error || "Erreur" };

        default:
            return state;
    }
}